import { createTheme, ThemeOptions } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

const theme: ThemeOptions = {
  palette: {
    primary: {
      main: "#528CD6",
      dark: "#002652",
      light: "#A3D4E8",
      base: "#E3F2F8",
      accent: "#FF9D14",
    },
    components: {
      slider: {
        rail: "#E3F2F8",
        track: "#002652",
        thumbIcon: "#F2704F",
        label: "#002652",
      },
      progressBar: {
        rail: "#D9D9D9",
        track: "#FF9D14",
      },
      buttonSelect: {
        backgroundColor: "#528CD6",
        textColor: "#FFFFFF",
        backgroundColorActive: "#002652",
        textColorActive: "#FFFFFF",
        bordeColorActive: "#A3D4E8",
      },
    },
  },
};

export const CustomTheme = createTheme(themeBase, theme);

export const interfaceConfig: InterfaceConfig = {
  name: "pymio",
  interest_rate: 30,
  maps: {
    api_key: import.meta.env.VITE_ENV === "PROD" ? "" : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  status_waiting_room: "CSEOF",
  url_waiting_room: "/producto/creditosimple/esperando_ofertas",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_tBa1HDVGi",
      userPoolClientId: "6ah7hc05bl7n6rqft7tdp7g8b3",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_76FjagSZI",
      userPoolClientId: "4hukgnioi4gqqkig3dr8slbp7k",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
